export enum DeployEnvironment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  SANDBOXV2 = 'sandboxV2',
  PRODUCTION = 'production',
}

export type KudosEnv = {
  API_URL: `https://${string}`
  ROLLBAR_SDK_ID: string
  DEPLOY_ENVIRONMENT: DeployEnvironment
  WEB_PUSH_VAPID_PUBLIC_KEY: string
  TRANSIFEX_TOKEN: string | null
  GIPHY_API_KEY: string
  DEFAULT_DOMAIN: string
  MUI_PRO_KEY: string
  FROALA_ENTERPRISE_KEY: string
  MS_TEAMS_APP_STORE: string
  MAINTENANCE_STATUS_PAGE_URL?: string
  APP_VERSION: string
  GAINSIGHT_PX_TAG_KEY: string
  LOGROCKET_APP_ID: string
}

export const envConfig: KudosEnv = {
  API_URL: 'https://k-api.kudos.com',
  ROLLBAR_SDK_ID: 'f7104f833fb649b39c741e4e8ba60a63',
  DEPLOY_ENVIRONMENT: DeployEnvironment.PRODUCTION,
  WEB_PUSH_VAPID_PUBLIC_KEY:
    'BNjyCqg37j_e94gBEqswFxwMjJ7M4saVRC6d3fa8BHLdFF_VqStK0yopPZtmPYMDmF8-qqu9uI62ipU4k8r3ZzI',
  TRANSIFEX_TOKEN: '1/c007c8aa8b1ec099eed4b2fa675309096c71e3fe',
  GIPHY_API_KEY: 'EspnLsorzUFYzXcKueH1qgKy7qBvlslF',
  DEFAULT_DOMAIN: 'https://my.kudos.com',
  MUI_PRO_KEY:
    'fdf9d970966a25062df3eb6f5813f132Tz0xMjk3MjAsRT0xODE1NTIzMTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=',
  FROALA_ENTERPRISE_KEY: 'aLF3c1A6B5D5E2F2B1F2xROKLJKYHROLDXDRH1e1YYGRe1Bg1G3I3A2A4D6B3D3E4E2A2==',
  MS_TEAMS_APP_STORE:
    'https://m365.cloud.microsoft/apps/?titleId=T_11abccfd-9bc1-f009-dce3-6dca1d0cbb5b&source=app-details-dialog-meta-os',
  MAINTENANCE_STATUS_PAGE_URL: 'https://status.kudos.com/',
  APP_VERSION: 'fcb680f3c64de6682c983d582a3667cc85da9f45',
  GAINSIGHT_PX_TAG_KEY: 'AP-LBY63WONOHMS-2',
  LOGROCKET_APP_ID: 'riz8z3/kudos-next-gen',
}
